import {ShoppingAccountService} from '../../api/services/shopping-account.service';
import {InputEventUtils} from '../../utils/input_event_utils';
import {ACCOUNT_OVERLAY_TYPE} from '../../shared/constants';

export class AccountEmailSent {
  constructor(private accountService: ShoppingAccountService, private wrapperEl: HTMLElement) {
    this.init();
  }

  private init() {
    const linkElToSignIn = this.wrapperEl.querySelector<HTMLElement>('.link-to-sign-in');

    InputEventUtils.addSelectEvents(linkElToSignIn, () =>
      this.accountService.setOverlayType(ACCOUNT_OVERLAY_TYPE.SIGN_IN)
    );
  }
}
